import ManageRole from './ManageRole';

export default ManageRole;
